import { SearchHint } from "../../data/model";

export class SearchState {
    constructor(
        public hint: SearchHint = {
            OfferExternalId: null,
            FirstName: null,
            LastName: null,
            EMail: null,
            Country: null,
            Zip: null,
            City: null,
            Street: null,
            StreetNumber: null,
            AgencyNumber: null,
            Occasion: null,
            Birthdate: null,
            BeginCreationDate: null,
            EndCreationDate: null,
            BeginFinalizationDate: null,
            EndFinalizationDate: null,
            Finalized: null,
        } as SearchHint,
        public extended = false,
    ) {}
}
